import Graphic from "@arcgis/core/Graphic";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { removeAllFromSelectionLayer } from "../select-form/spatial-select/spatialSelectVM";

const workOrderFieldName = "WorkOrderNumber";
const workOrderStatusFieldName = "AIMStatus";
const pointStatusFieldName = "Status";
const StatusAfterWorkOrderCreated = "Assigned to Work Order";
export const updateFeaturesInGisWithWorkOrderResults = async ({dto,response}) => {
  let fulfilled="fulfilled";
  let ok = 200
  // console.log(workOrdersCreated)

  // if(workOrdersCreated.length<1){
  //   return;
  // }
  // let gisResultUpdatesArray: Promise<any>[] = [];
  //for (const workOrder of workOrdersCreated) {
    // const { dto, response } = workOrder;
    if(response.status===fulfilled && response.value.status===ok){
    const { proposal,statusCode } = response.value?.data;
    console.log(proposal,statusCode)
    const featureMap = createFeatureMap(dto.features);
    const gisUpdate=await applyEditsToLayers(featureMap,{proposal,statusCode});
      //gisResultUpdatesArray.push(gisUpdate);

        if (gisUpdate) {
    return gisUpdate;
  } else {
    console.warn("No valid work orders to update in GIS.");
    return {};
  }
  }
//}

}

interface Feature {
    layer: FeatureLayer;
    attributes: {
      OBJECTID: number;
    };
    parentLayerId: number;
  }
  
  const createFeatureMap = (features: Feature[]): Map<number, { OCLandInsightsID:any; parentLayerUrl:any; objectIds: number[] }> => {
    const featureMap = new Map<number, { OCLandInsightsID:any; parentLayerUrl:any; objectIds: number[] }>();
  
    features.forEach((feature) => {
      const { parentLayerId,parentCustomParameters, parentLayerUrl, attributes, } = feature as any;
      const { OCLandInsightsID } = parentCustomParameters;
      const { OBJECTID } = attributes;
  
      if (featureMap.has(parentLayerId)) {
        featureMap.get(parentLayerId)?.objectIds.push(OBJECTID);
      } else {
        featureMap.set(parentLayerId, { OCLandInsightsID,parentLayerUrl, objectIds: [OBJECTID] });
      }
    });
  
    return featureMap;
  };

  //revisit to control the fields and values that are updated, not just proposal
  const applyEditsToLayers = async (featureMap: Map<number, { OCLandInsightsID: any; parentLayerUrl: string; objectIds: number[] }>, fields) => {
    const {proposal,statusCode} = fields;
    for (const [parentLayerId, { OCLandInsightsID, parentLayerUrl, objectIds }] of featureMap.entries()) {
      const layer = await new FeatureLayer({ url: `${parentLayerUrl}/${OCLandInsightsID}` }).load();
      console.log(layer)
      let workOrderField:string=""
      let workOrderStatusField:string=""
      let workOrderFieldFound=false;
      let workOrderStatusFieldFound=false;
      for (const field of layer.fields) {
        if (field.name === workOrderFieldName) {
          workOrderField=workOrderFieldName
          workOrderFieldFound = true;
        }
        if (field.name === workOrderStatusFieldName) {
          workOrderStatusField=workOrderStatusFieldName
          workOrderStatusFieldFound = true;
        }
        if(workOrderFieldFound && workOrderStatusFieldFound){
          break;
        }
      }
      if (!workOrderFieldFound) {
        console.warn(`No work order field found for layer ${parentLayerId}`);
      }
      if (!workOrderStatusFieldFound) {
        console.warn(`No work order status field found for layer ${parentLayerId}`);
      }
      const edits = {
        updateFeatures: objectIds.map((OBJECTID) => new Graphic({
          attributes: {
            OBJECTID,
            [workOrderField]:proposal,
            [workOrderStatusField]:statusCode,
            [pointStatusFieldName]:StatusAfterWorkOrderCreated
          },
        })),
      };
  
      try {
        const result = await layer.applyEdits(edits);
        console.log(`Edits applied to layer ${parentLayerId}:`, result);
        return result
      } catch (error) {
        console.error(`Failed to apply edits to layer ${parentLayerId}:`, error);
      }
    }
  };
  
